import { ComponentChildren, FunctionalComponent, h } from "preact";
import { Color } from "utils/color";

import style from "./style.scss";

interface Props {
  children: ComponentChildren;
  className?: string;
  color?: Color["name"];
  href?: string;
  onClick?: (e: MouseEvent) => void;
  uppercase?: boolean;
  style?: "flat" | "outline";
  tag: "a" | "button";
  type?: "button" | "submit";
}

export const Button: FunctionalComponent<Props> = (props: Props) => {
  return (
    <props.tag
      class={`${style.root} ${props.className ?? ""}`}
      data-uppercase={props.uppercase}
      data-color={props.color}
      data-style={props.style ?? "flat"}
      href={props.href}
      type={props.type}
      onClick={props.onClick}
    >
      {props.children}
    </props.tag>
  );
};
